"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internal
 * Set the marker of a bullet list
 * @param li
 * @param listStyleType
 */
function setBulletListMarkers(li, listStyleType) {
    var marker = bulletListStyle[listStyleType];
    var isDisc = listStyleType === 1 /* Disc */;
    li.style.listStyleType = isDisc ? marker : "\"" + marker + "\"";
}
exports.default = setBulletListMarkers;
var bulletListStyle = (_a = {},
    _a[1 /* Disc */] = 'disc',
    _a[3 /* Square */] = '∎ ',
    _a[2 /* Dash */] = '- ',
    _a[5 /* LongArrow */] = '➔ ',
    _a[8 /* DoubleLongArrow */] = '➔ ',
    _a[4 /* ShortArrow */] = '➢ ',
    _a[6 /* UnfilledArrow */] = '➪ ',
    _a[7 /* Hyphen */] = '— ',
    _a);
//# sourceMappingURL=setBulletListMarkers.js.map